import * as THREE from "three";
import Experience from "../../../Experience.js";

export default class FloorRocks {
    constructor() {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;
        this.resource = this.resources.items.floorRocks;
        this.texture = this.resources.items.rockTexture;

        this._setModel();
    }

    _setModel() {
        this.model = this.resource.scene;

        // Scale and position can be adjusted as needed
        this.model.position.set(0, -20.5, 0);

        this.model.traverse((child) => {
            // should be single mesh/child
            if (child instanceof THREE.Mesh) {
                child.castShadow = true;
                child.receiveShadow = true;

                // Replace material with a new MeshPhongMaterial to ensure it reacts to ambient light
                child.material = new THREE.MeshPhongMaterial({
                    map: this.texture,
                    shininess: 20,
                    shadowSide: THREE.FrontSide,
                });
                this.mesh = child; // Store the mesh for later use
            }
        });
    }
}
